<div class="tw-flex tw-justify-between">
    <h2 mat-dialog-title>
        {{ 'OUTGOING-GOODS.ADD-TO-BUNDLE-DIALOG.TITLE' | translate }}
    </h2>

    <button aria-label="Schließen"
        mat-icon-button
        mat-dialog-close>
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
</div>

<div class="table-container">
    <app-generic-table
        [data]="tableData()"
        [columns]="columns"
        [config]="tableConfig"
        [loading]="tableLoading()"
        [sortable]="true"
        [filterable]="false"
        [paginated]="true"
        [showFilter]="false"
        [showPagination]="true"
        [emptyStateMessage]="'GENERAL.NO-DATA'"
        (sortChange)="onSortChange($event)">
    </app-generic-table>
</div>

<mat-dialog-actions align="end">
    <button
        mat-button
        mat-dialog-close>
        {{ 'OUTGOING-GOODS.ADD-TO-BUNDLE-DIALOG.CANCEL' | translate }}
    </button>
    <button
        mat-raised-button
        color="primary"
        (click)="addNotesToBundle()"
        cdkFocusInitial
        [disabled]="!selectionStore.hasSelection() || loading()"
        [class.spinner]="loading()">
        {{ 'OUTGOING-GOODS.ADD-TO-BUNDLE-DIALOG.ACTION' | translate }}
    </button>
</mat-dialog-actions>
